export default "__VITE_ASSET__DJKWw4ft__"